var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgArtCarouselCreditCard = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0V0z",
    id: "p7931vvnta"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    xlinkHref: "#p7931vvnta"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m48.466 6.45-2.2-1.379a1.35 1.35 0 0 0-1.334.278l-32.92 20.078c-.197.22-.432.533-.626.947a4.252 4.252 0 0 0-.379 2.03V52.99a.546.546 0 0 0 .359.513l1.977 1.17.46-27.18L48.466 6.45z",
    fill: "#F1CA6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.152 53.847V29.728c-.015-.346-.013-1.358.65-2.236.242-.323.51-.542.731-.687l32.735-20.08.689-.38a.937.937 0 0 1 .668.19c.433.344.373.948.371.976v24.94c-.062.296-.208.82-.588 1.351-.36.506-.769.792-1.014.94L14.465 54.82c-.054.04-.328.239-.66.161-.359-.084-.637-.458-.66-.92",
    fill: "#F6E4B3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473C20",
    d: "M13.174 31.886v3.857l35.812-21.787V9.957"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.828 36.116v7.91l29.46-17.929v-7.985"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#473C20",
    d: "M33.508 36.717v.5l13.024-8.043v-.557M33.551 38.527v.5l13.022-8.043v-.557M33.584 40.25v.498l13.024-8.044v-.554"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.527 51.662v-4.626a1.15 1.15 0 0 1 .631-.667l3.316-2.017c.198-.02.365.056.414.182.01.027.023.07.015.131v4.404c0 .06-.013.202-.107.342a.604.604 0 0 1-.355.25l-3.627 2.198c-.132.049-.242.047-.275-.006a.077.077 0 0 1-.01-.043l-.004-.15.002.002z",
    fill: "#E8B240"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArtCarouselCreditCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/art-carousel-credit-card.1e50077ceea2e57c022cae11579877f1.svg";